export interface RecipeIngredientDiary {
  RecipeIngredientDiaryId: string;
  CustomerId: string;
  RecipeIngredientHeaderId: string;
  ActionType: number;
  ActionSummary: string[];
  AdditionalData: string;
  ChangeByUser: string;
  CreateDate: Date | string;
  ChangeDate: Date | string;
  DeleteDate?: Date | string;
}

export type GetRecipeIngredientDiarysRequest = {
  CustomerId: string;
  IngredientId: string;
  StartDate: Date | string;
  EndDate: Date | string;
};

export enum RecipeIngredientDiaryActionType {
  RecipeIngredientHeader_Add = 0,
  RecipeIngredientHeader_Update = 1,
  RecipeIngredientHeader_Remove = 2,

  RecipeIngredientProduct_Add = 3,
  RecipeIngredientProduct_Update = 4,
  RecipeIngredientProduct_Remove = 5,

  RecipeIngredientCustomerProductPrimary_Set = 6,
  RecipeIngredientHeader_Recover = 7,
  RecipeIngredientProduct_Sequence = 8,
}

export type RecipeCustomerIngredientDiary = {
  RecipeCustomerIngredientDiaryId: string;
  CustomerId: string;
  ActionType: number;
  ActionSummary: string[];
  AdditionalData: string;
  ChangeByUser: string;
  CreateDate: Date | string;
  ChangeDate: Date | string;
  DeleteDate?: Date | string;
  CanRevert: boolean;
};

export type RevertRecipeCustomerIngredientDiaryActionRequest = {
  RecipeCustomerIngredientDiaryId: string;
};

export enum RecipeCustomerIngredientDiaryActionType {
  RecipeIngredientCategory_Add = 0,
  RecipeIngredientCategory_Update = 1,
  RecipeIngredientCategory_Delete = 2,

  RecipeIngredientHeader_Remove = 3,
  RecipeIngredientCategory_Recover = 4,
}
